import type { SVGProps } from "react";

const SvgComponent = ({
	muted,
	...props
}: SVGProps<SVGSVGElement> & { muted?: boolean }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			fill="var(--svg-color, currentColor)"
			d="M11.4 3.15a1 1 0 0 1 .6.92v15.86a1 1 0 0 1-1.62.78L5.65 16.7H3a1 1 0 0 1-1-1V8.3a1 1 0 0 1 1-1h2.65l4.73-4.01a1 1 0 0 1 1.02-.14"
		/>
		{muted ? (
			<path
				stroke="var(--svg-color, currentColor)"
				strokeWidth="1.7"
				strokeLinecap="round"
				d="m16.5 9.5 5 5m0-5-5 5"
			/>
		) : (
			<path
				stroke="var(--svg-color, currentColor)"
				strokeWidth="1.7"
				strokeLinecap="round"
				d="M16.5 8.8a4.5 4.5 0 0 1 0 6.4M19 6.2a8 8 0 0 1 0 11.6"
			/>
		)}
	</svg>
);

export { SvgComponent as SoundIcon };
